import { Badge } from '@aws-amplify/ui-react'
import { 
  FaRegCheckCircle,
  FaRegCircle,
  FaEdit
} from 'react-icons/fa'
import { formatDateISOToTh, formatNumberV2 } from '../utilities/Format'
import { DgtPdProductionOrder } from '../models'
import { FGInspectionTypes } from '../constants/EnumType'

import { memo } from 'react'
import { getBrandLogoUrl } from '../utilities/Image'

type OrderCardProps = {
  productionOrder: DgtPdProductionOrder,
  onEdit: (order : DgtPdProductionOrder) => void,
  readonly: boolean
}

const OrderCard = memo(({ 
  productionOrder,
  onEdit,
  readonly
}: OrderCardProps) => {
  const { 
    id, 
    materialCode, 
    materialDescription, 
    division, 
    orderQty, 
    materialUnit,
    materialMrp,
    fgInspectionTypes,
    createdAt
  } = productionOrder
  const brandLogoUrl = getBrandLogoUrl(materialMrp || '')
  const selectedFGInspectionForms : string[] = fgInspectionTypes ? JSON.parse(fgInspectionTypes) : [];
  
  return <div className={`w-full px-6 py-[18px] rounded-xl shadow flex-col justify-start items-start gap-6 inline-flex${fgInspectionTypes ? ' bg-green-50' : ' bg-white'}`}>
    <div className="flex-col justify-start items-start gap-[9px] flex w-full">
      <div className="inline-flex items-start justify-between w-full gap-10">
        <h6 className="font-normal text-stone-500">#{id}</h6>
        <img alt="" className=" w-[48px] h-[42px]" src={brandLogoUrl} />
      </div>
      <div className="flex flex-col items-start justify-start gap-2">
        <Badge>{materialCode}</Badge>
        <h4 className="font-medium">{materialDescription}</h4>
      </div>
      <div className="w-full items-start justify-between gap-2.5 inline-flex">
        <h6 className="font-normal text-stone-500">{division}</h6>
        <h6 className="font-normal text-stone-500">{formatNumberV2(orderQty)} {materialUnit}</h6>
      </div>
      <small className='italic text-muted'>Release เมื่อ : {formatDateISOToTh(createdAt)}</small>
    </div>
    <hr className='w-full mt-2 border-t border-stone-300'/>
    <div className='flex flex-wrap justify-center gap-3 py-3'>
      {Object.keys(FGInspectionTypes).map((key) => {
        const fgInspectionType = FGInspectionTypes[key as keyof typeof FGInspectionTypes];
        return selectedFGInspectionForms.includes(fgInspectionType) ? 
          <Badge key={key} variation={fgInspectionType.startsWith('PD') ? 'success' : 'error'} size="small"><FaRegCheckCircle className='mr-1'/>{fgInspectionType}</Badge> : 
          <Badge key={key} size="small" className='badge-unselected-form'><FaRegCircle className='mr-1'/>{fgInspectionType}</Badge>
      })}
    </div>
    <button disabled={readonly} className='w-full gap-3 btn-order-claim' onClick={() => onEdit(productionOrder)}><FaEdit />เลือก FORM</button>
  </div>
})

export default OrderCard